import React, { Component } from "react";
import MenuBar from "./common/MenuPanel";
import FooterPanel from "./common/FooterPanel";

import VideoPanel from "./home/VideoPanel";
import BishopPanel from "./home/BishopPanel";
import HealingPanel from "./home/HealingPanel";
import MinistriesPanel from "./home/MinistriesPanel";
import EventsPanel from "./home/EventsPanel";
import PrayerRequestPanel from "./home/PrayerRequestPanel";

import { withTranslation } from "react-i18next";

class HomePanel extends Component {
  render() {
    const { i18n } = this.props;
    const language = i18n.language || "en";

    return (
      <React.Fragment>
        <div className="container-fluid position-relative p-0">
          <MenuBar language={language} />
          <VideoPanel language={language} />
        </div>
        <BishopPanel language={language} />
        <HealingPanel language={language} />
        <EventsPanel language={language} />
        <PrayerRequestPanel language={language} />
        <MinistriesPanel language={language} />
        <FooterPanel language={language} />
      </React.Fragment>
    );
  }
}

export default withTranslation()(HomePanel);
